/**
 * Labels external provenance consistently wherever connected content appears.
 *
 * A shared badge prevents Box, Kuali, Workday, and native DocReview sources
 * from being confused with authorization or from acquiring page-specific names.
 */
import { Badge } from '@/components/ui'
import { sourceProviderLabel } from '@/subsystems/vault/lib/provider-labels'

export function SourceProviderBadge({ provider }: { provider?: string | null }) {
  if (!provider) return null
  return (
    <Badge variant="outline" className="h-5 shrink-0 bg-background text-[10px] font-medium">
      {sourceProviderLabel(provider)}
    </Badge>
  )
}
